var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 40,
    viewBox: "0 0 212 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6799 11.0909L20.7146 6.43471L16.0766 11.0909L12.6188 8.11901L20.7146 0L28.7312 7.97355L25.6799 11.0909Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0766 11.0909L20.7146 0L12.6188 8.11901L16.0766 11.0909Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.731 7.97355L20.7145 0L25.6798 11.0909L28.731 7.97355Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8112 28.9786L20.7781 33.6348L25.4145 28.9786L28.5913 32.2332L20.7781 40.0695L12.7616 32.096L15.8112 28.9786Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7781 40.0695L12.7616 32.096L15.8112 28.9786L20.7781 40.0695Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5908 32.2333L20.7776 40.0697L25.414 28.9788L28.5908 32.2333Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4398 20.1803L27.5175 27.1027L30.734 30.3208L40.8745 20.1803L30.7356 10.0415L27.5175 13.2597L34.4398 20.1803Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5176 27.1021L40.8746 20.1798L30.7341 30.3203L27.5176 27.1021Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8745 20.1803L27.5175 13.2597L30.7356 10.0415L40.8745 20.1803Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43398 20.182L13.3546 13.2597L10.1398 10.0415L-0.000732422 20.182L10.1381 30.3208L13.3546 27.1027L6.43398 20.182Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3546 27.1022L-0.000732422 20.1815L10.1381 30.3204L13.3546 27.1022Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3546 13.2597L-0.000732422 20.182L10.1398 10.0415L13.3546 13.2597Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8569 23.4132L16.6867 20.2413L19.8569 17.0727V10.5289L10.252 20.2413L19.8569 29.8479V23.4132Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2584 20.2L19.8634 17.0314V10.4761L10.2584 20.2Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8634 23.3704L10.2584 20.2002L19.8634 29.8068V23.3704Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4958 23.4069L24.6661 20.2367L21.4958 17.0664V10.5243L31.1008 20.2367L21.4958 29.8416V23.4069Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1008 20.2367L21.4958 17.0664V10.5243L31.1008 20.2367Z",
    fill: "#5A00CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5154 29.7376V23.3856L31.1633 20.2004L21.5154 29.7376Z",
    fill: "#5A00CD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7816 10H68.7369V21.2239C68.7369 27.1642 64.6175 30 58.7966 30C52.9458 30 48.8264 27.1642 48.8264 21.2239V10H55.8115V20.7463C55.8115 22.7761 56.7667 23.9104 58.7966 23.9104C60.7667 23.9104 61.7816 22.7761 61.7816 20.7463V10Z",
    fill: "#5A00CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.725 15.4925V10H89.6803V29.6418H82.934L75.4713 20.6269L75.4116 20.6567C75.4116 20.6567 75.6206 22.8358 75.6206 24.0896V29.6418H68.6653V10H75.6206L82.8444 18.7463L82.9041 18.7164C82.9041 18.7164 82.725 16.6269 82.725 15.4925Z",
    fill: "#5A00CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3069 29.6418V10H101.561C107.62 10 110.426 12.8955 110.426 17.1642C110.426 19.6119 109.561 21.5821 107.77 22.7463V22.8358L111.262 29.6418H103.62L100.725 24.0896H99.2621V29.6418H92.3069ZM99.2621 19.3433H101.262C102.964 19.3433 103.68 18.7463 103.68 17.4627C103.68 16.4776 103.173 15.6418 101.322 15.6418H99.2621V19.3433Z",
    fill: "#5A00CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.162 21.9702H119.61V24.0597H128.953V29.6418H112.654V10H128.565V15.6119H119.61V17.5224H127.162V21.9702Z",
    fill: "#5A00CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.961 10H139.887C146.066 10 148.991 13.0746 148.991 17.6119C148.991 22.4776 146.036 25.2537 140.812 25.2537H137.917V29.6418H130.961V10ZM137.917 20.0597H139.767C141.499 20.0597 142.245 19.3134 142.245 17.9104C142.245 16.9552 141.797 15.8806 139.618 15.8806H137.917V20.0597Z",
    fill: "#5A00CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.35 21.9702H157.798V24.0597H167.141V29.6418H150.842V10H166.753V15.6119H157.798V17.5224H165.35V21.9702Z",
    fill: "#5A00CD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.597 10H184.701L192.373 29.6418H184.463L183.388 26.5672H176.881L175.836 29.6418H167.925L175.597 10ZM179 19.6119L178.343 21.4627H181.955L181.269 19.6119C180.91 18.5373 180.254 16.0299 180.254 16.0299H180.015C180.015 16.0299 179.358 18.5075 179 19.6119Z",
    fill: "#5A00CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.764 29.6418V16.0896H184.701V10H211.332L206.395 16.0896H202.719V29.6418H195.764Z",
    fill: "#5A00CD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8264,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30c6021fecc619f5df030b5d49825205.svg";
export { ForwardRef as ReactComponent };